var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.report.internalMonitoring
    ? _c(
        "div",
        [
          _c("h2", { attrs: { tabindex: "-1" } }, [
            _vm._v(_vm._s(_vm.$t("Title_InternalMonitoring")))
          ]),
          _vm._v(" "),
          _c("radio-button-table-row", {
            attrs: {
              title: "InternalMonitoring.Title",
              instructionKey: "InternalMonitoring.Title_Instructions",
              columnHeader: "Title_InternalMonitoring",
              required: true,
              items: _vm.report.internalMonitoring.items
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "mt-4 row",
              attrs: {
                role: "group",
                "aria-labelledby": "InternalMonitoring.RegulationsTtile"
              }
            },
            [
              _c("plain-text-control", {
                staticClass: "col-12 col-sm-4",
                attrs: {
                  id: "InternalMonitoring.RegulationsTtile",
                  title: "InternalMonitoring.RegulationsTitle"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 col-sm-8" }, [
                _c(
                  "div",
                  { staticClass: "form-check" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.report.internalMonitoring.hasLiteralRegulations,
                          expression:
                            "report.internalMonitoring.hasLiteralRegulations"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "checkbox",
                        id: "LiteralRegulations",
                        name: "InternalMonitoring.Regulations",
                        disabled: _vm.isReadOnly,
                        "aria-disabled": _vm.isReadOnly
                      },
                      domProps: {
                        checked: Array.isArray(
                          _vm.report.internalMonitoring.hasLiteralRegulations
                        )
                          ? _vm._i(
                              _vm.report.internalMonitoring
                                .hasLiteralRegulations,
                              null
                            ) > -1
                          : _vm.report.internalMonitoring.hasLiteralRegulations
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$a =
                                _vm.report.internalMonitoring
                                  .hasLiteralRegulations,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.report.internalMonitoring,
                                    "hasLiteralRegulations",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.report.internalMonitoring,
                                    "hasLiteralRegulations",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.report.internalMonitoring,
                                "hasLiteralRegulations",
                                $$c
                              )
                            }
                          },
                          function($event) {
                            return _vm.forceSave()
                          }
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c("label-control", {
                      staticClass: "form-check-label",
                      attrs: {
                        forElement: "LiteralRegulations",
                        title: "InternalMonitoring.LiteralRegulations"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "form-check" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value:
                          _vm.report.internalMonitoring
                            .hasLiteralTravelInstructions,
                        expression:
                          "report.internalMonitoring.hasLiteralTravelInstructions"
                      }
                    ],
                    staticClass: "form-check-input",
                    attrs: {
                      type: "checkbox",
                      id: "LiteralTravelInstructions",
                      name: "InternalMonitoring.Regulations",
                      disabled: _vm.isReadOnly,
                      "aria-disabled": _vm.isReadOnly
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.report.internalMonitoring
                          .hasLiteralTravelInstructions
                      )
                        ? _vm._i(
                            _vm.report.internalMonitoring
                              .hasLiteralTravelInstructions,
                            null
                          ) > -1
                        : _vm.report.internalMonitoring
                            .hasLiteralTravelInstructions
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a =
                              _vm.report.internalMonitoring
                                .hasLiteralTravelInstructions,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.report.internalMonitoring,
                                  "hasLiteralTravelInstructions",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.report.internalMonitoring,
                                  "hasLiteralTravelInstructions",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.report.internalMonitoring,
                              "hasLiteralTravelInstructions",
                              $$c
                            )
                          }
                        },
                        function($event) {
                          return _vm.forceSave()
                        }
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "form-check-label",
                      attrs: { for: "LiteralTravelInstructions" }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("InternalMonitoring.LiteralTravelInstructions")
                        )
                      )
                    ]
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }